/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import useUserStore from '../../../store/userStore/userStore';

const getSustainabilityResponses = async (): Promise<any> => {
  const token = useUserStore.getState().userToken;
  const companyId = useCompanyStore.getState().companyId;

  try {
    const res = await axios.request({
      method: CRUDMethods.GET,
      url: `${API_BASE_URL}${API_ENDPOINT_JSON.sustainabilityResponses}/${companyId}`,
      data: {},
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {}
    });

    return res.data.data?.[0]?.data;
  } catch (err: any) {
    return err?.response?.data;
  }
};

export default getSustainabilityResponses;
